<template>
    <div  v-if="job.isPureContact">
        <button class="btn btn-primary full-width" @click="$emit('skipStep')" v-on:keyup.83="$emit('skipStep')">{{'SKIP'|trans}}</button>
    </div>
</template>


<script>
    export default {
        props: {
            job : Object
        }
    }

</script>

